module.exports = __webpack_public_path__ + "4a49392120eb501bf764943aafcb0ca9.svg";